// Styles for CarouselGalleryTriptych go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledCarouselGalleryTriptych = styled.div`
  padding: 0 !important;

  .left-arrow,
  .right-arrow,
  .left-arrow::after,
  .right-arrow::before {
    color: ${baseVariables.color['base10']};
  }
  .glide__bullet--active::after {
    background-color: ${baseVariables.color['base10']};
  }

  .color-class {
    .left-arrow,
    .right-arrow,
    .left-arrow::after,
    .right-arrow::before {
      color: ${baseVariables.color['base20']};
    }
    .glide__bullet--active::after {
      background-color: ${baseVariables.color['base20']};
    }
  }

  .right-arrow,
  .left-arrow {
    width: fit-content;
  }

  [dir='rtl'] & {
    .right-arrow::before {
      margin-left: ${toRem(24)} !important;
    }
    .left-arrow::after {
      margin-right: ${toRem(24)};
    }
  }
`;
